import type { SxProps, Theme } from '@mui/material';
import { Skeleton } from '@mui/material';

export type ReportMetricValueSkeletonProps = {
  sx?: SxProps<Theme>;
};

export function ReportMetricValueSkeleton({
  sx,
}: ReportMetricValueSkeletonProps) {
  return (
    <Skeleton
      variant="rounded"
      animation="wave"
      sx={[
        (theme) => ({
          width: '75%',
          maxWidth: 240,
          height: theme.typography.h3.fontSize,
        }),
        ...(sx != null ? [sx].flat() : []),
      ]}
    />
  );
}
